<template>
  <div class="eds-main">
    <div class="scroll-container docx-cont">
      <div class="docx-container resized" :style="{ '--zoom': zoom, '--width': width }">
        <div ref="docxRef" class="docx-wrapper docx"></div>
      </div>
    </div>
    <div class="user-actions">
      <SideInfo v-if="dataStore.contractInfo.organization" :is-mine="false" />
      <SideInfo :is-mine="true" />

      <!-- {{ dataStore.contractInfo }}-->
      <a :href="'/api/download/user/' + uuid">
        <Button>Скачать документ</Button>
      </a>
      <!-- <Button v-if="!dataStore.contractInfo.link_sended" class="secondary" @click="sendSmsInvite"
        >Приглашение по SMS
      </Button> -->
    </div>
  </div>
</template>
<script setup>
import { inject, ref } from 'vue'
// Переадресация на /auth
import { onMounted } from 'vue'
import api from '@/api'
import { renderAsync } from 'docx-preview'
import SideInfo from '#/SideInfo.vue'
import Button from '#/inputs/Button.vue'
import { useDataStore } from '@/stores/dataStore'
const docxRef = ref(null)
const zoom = ref(1)
const width = ref(600)
const uuid = ref('')
const showError = inject('showError')
const dataStore = useDataStore()
onMounted(async () => {
  // get url params
  const params = new URLSearchParams(location.search)
  uuid.value = params.get('uuid')
  if (!uuid.value) {
    showError('Не указан uuid')
    return
  }
  // Загружаем данные при первом заходе
  await dataStore.loadData(uuid.value)
  setTimeout(() => {
    loadAndRenderDocx()
  }, 1)
  resizeDocx()
})

async function loadAndRenderDocx() {
  try {
    const response = await api.get('/download/' + uuid.value, {
      responseType: 'blob' // важный момент!
    })
    if (response.status !== 200) {
      showError(response.data)
      return
    }

    const fileBlob = response.data
    console.log(docxRef.value)

    await renderAsync(fileBlob, docxRef.value, null, {
      inWrapper: false,
      // hideWrapperOnPrint: true,
      ignoreWidth: true,
      className: 'docx'
      // ignoreHeight: true,
      // breakPages: true,
      // renderHeaders: true,
      // renderFooters: true,
      // // renderEndnotes: true,
      // ignoreFonts: true,
      // debug: false,
      // experimental: true,
      // trimXmlDeclaration: false,
      // renderFootnotes: false,
      // ignoreLastRenderedPageBreak: false,
      // useBase64URL: true,
      // renderChanges: true,
      // renderComments: true,
      // renderAltChunks: false
    })
  } catch (error) {
    console.error('Ошибка при загрузке или рендере docx:', error)
  }
}
// on resize
const baseWidth = 608
window.addEventListener('resize', () => {
  resizeDocx()
})
// const sendSmsInvite = async () => {
//   try {
//     const response = await api.put('/sendLink', { contract_id: uuid.value })
//     if (response.status !== 200) {
//       showError(response.data)
//       return
//     }
//     dataStore.contractInfo.link_sended = true
//   } catch (error) {
//     showError(error.response.data || 'Ошибка при отправке приглашения по SMS')
//   }
// }
const resizeDocx = () => {
  const docxCont = document.querySelector('.docx-cont')
  console.log(docxCont.clientWidth)
  console.log(docxCont.clientWidth / baseWidth)
  zoom.value = docxCont.clientWidth / baseWidth
  width.value = `${(1 / zoom.value) * 100}%` // свистопляска для нормализации контейнера документа
}
</script>

<style scoped>
.eds-main {
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: var(--base-gap);
  height: calc(100vh - 20px);
  width: 100%;
}
.user-actions {
  display: flex;
  flex-direction: column;
  gap: var(--base-gap);
  max-width: 450px;
}
.user-actions a {
  text-decoration: none;
  width: 100%;
  display: flex;
  justify-content: center;
}
a button {
  width: 100%;
}

/* .docx-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #000000;
  overflow: auto;
} */

.docx-cont {
  /* max-width: 1000px; */
  height: 100%;
  flex: 1;
  max-width: 100%;
}
.scroll-container {
  /* height: calc(99vh - 20px); */
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: auto;
}
</style>
<style>
.resized {
  -ms-transform: scale(var(--zoom));
  -moz-transform: scale(var(--zoom));
  -o-transform: scale(var(--zoom));
  -webkit-transform: scale(var(--zoom));
  transform: scale(var(--zoom));

  -ms-transform-origin: top left;
  -moz-transform-origin: top left;
  -o-transform-origin: top left;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  /* width: fit-content; */
  height: 100%;
  width: var(--width);
}
/* 
@media (min-width: 1200px) {
}
/* mobile */

@media (max-width: 1100px) {
  .eds-main {
    flex-direction: column !important;
    align-items: center;
  }
  .user-actions {
    max-width: 100% !important;
  }
}

.docx {
  padding: 0px !important;
  background-color: white;
}

p:empty {
  display: none;
}

:root {
  --base-border-radius: 16px;
  --base-padding: 8px;
  --base-gap: 8px;
  --base-color: #a463ff;
}
</style>
